import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import { routerReducer as router } from "react-router-redux";
import { reducer as toastrReducer } from "react-redux-toastr";
import session from "MODULES/session/reducer";
import accountingLogs from "MODULES/AccountingLogs/pagination";
import commissions from "MODULES/Commissions/pagination";
import companyPagination from "MODULES/companies/pagination";
import consignments from "MODULES/Consignments/pagination";
import purchasesReport from "MODULES/PurchasesReport/pagination";
import salesReport from "MODULES/SalesDashboard/pagination";
import customerRMA from "MODULES/CustomerRmas/pagination";
import partPagination from "MODULES/parts/pagination";
import users from "MODULES/users/pagination";
import userDetail from "MODULES/users/reducer";
import partDetail from "MODULES/parts/reducer";
import companyDetail from "MODULES/companies/reducer";
import consignmentDetail from "MODULES/Consignments/reducer";
import notifications from "APP_ROOT/Nav/Notifications/reducer";
import incomingQuotes from "MODULES/IncomingQuotes/pagination";
import incomingQuoteWithAllLineItemsDetail from "MODULES/IncomingQuotes/incomingQuoteWithAllLineItemsReducer";
import incomingQuoteDetail from "MODULES/IncomingQuotes/reducer";
import outgoingQuoteDetail from "MODULES/OutgoingQuotes/reducer";
import outgoingQuotes from "MODULES/OutgoingQuotes/pagination";
import purchaseOrdersPagination, {
  purchaseOrderLineItems
} from "MODULES/PurchaseOrders/pagination";
import purchaseOrderDetail from "MODULES/PurchaseOrders/reducer";
import receivingRecordDetail from "MODULES/Receiving/reducer";
import receivingRecords, { discrepancies } from "MODULES/Receiving/pagination";
import rejectedCoreDetail from "MODULES/RejectedCores/reducer";
import rejectedCorePagination from "MODULES/RejectedCores/pagination";
import repairOrders, {
  repairOrderLineItems,
  reservedForRepairInventory
} from "MODULES/RepairOrders/pagination";
import repairOrderDetail from "MODULES/RepairOrders/reducer";
import reports from "MODULES/Admin/Reports/pagination";
import inventoryPagination from "MODULES/inventories/pagination";
import inventoryDetail from "MODULES/inventories/reducer";
import lots from "MODULES/Lots/pagination";
import lotDetail from "MODULES/Lots/reducer";
import mroDetail from "MODULES/ManagedRepairOrders/reducer";
import mros, {
  managedRepairOrderLineItems
} from "MODULES/ManagedRepairOrders/pagination";
import mistakeShipments from "MODULES/MistakeShipments/pagination";
import mistakeShipmentDetail from "MODULES/MistakeShipments/reducer";
import {
  receivingDashboardOrders,
  virtualReceivingDashboardOrders
} from "MODULES/Receiving/Dashboard/pagination";
import salesOrders, {
  reservedForSaleInventory
} from "MODULES/SalesOrders/pagination";
import salesOrderDetail from "MODULES/SalesOrders/reducer";
import salesOrderWithAllLineItemsDetail from "MODULES/SalesOrders/salesOrderWithAllLineItemsReducer";
import outboundOrders from "MODULES/Shipping/pagination";
import shipmentsPagination from "MODULES/OutgoingShipments/pagination";
import shipmentDetail from "MODULES/OutgoingShipments/reducer";
import rmas from "MODULES/RMAsAndWarranties/pagination";
import rmaDetail from "MODULES/RMAsAndWarranties/reducer";
import searchNotifications from "MODULES/Notifications/pagination";
import vendorRmas from "MODULES/VendorRmas/pagination";
import upgrade from "MODULES/Upgrade/reducer";
import subscriptions from "MODULES/Subscription/reducer";
import approvedVendors from "MODULES/ApprovedVendors/pagination";
import approvedRepairStations from "MODULES/ApprovedRepairStations/pagination";
import shoppingLists, {
  residentExpertSearch
} from "MODULES/MyShoppingList/pagination";
import consignmentReport from "MODULES/Admin/ConsignmentReportCard/pagination";

export default combineReducers({
  router,
  form,
  toastr: toastrReducer,
  session,
  commissions: commissions.paginator,
  companyDetail,
  companyPagination,
  consignmentReports: consignmentReport.paginator,
  consignments,
  consignmentDetail,
  customerRmas: customerRMA.paginator,
  purchasesReport: purchasesReport.paginator,
  discrepancies,
  incomingQuotes,
  incomingQuoteDetail,
  incomingQuoteWithAllLineItemsDetail,
  lots,
  lotDetail,
  notifications,
  searchAccountingLogs: accountingLogs.paginator,
  searchNotifications: searchNotifications.paginator,
  managedRepairOrderLineItems,
  mistakeShipments: mistakeShipments.paginator,
  mistakeShipmentDetail,
  mroDetail,
  managedRepairOrders: mros.paginator,
  outgoingQuotes: outgoingQuotes.paginator,
  outgoingQuoteDetail,
  partPagination,
  purchaseOrdersPagination,
  purchaseOrderDetail,
  purchaseOrderLineItems,
  partDetail,
  receivingRecords,
  receivingRecordDetail,
  receivingDashboardOrders: receivingDashboardOrders.paginator,
  rejectedCoreDetail,
  rejectedCores: rejectedCorePagination.paginator,
  virtualReceivingDashboardOrders: virtualReceivingDashboardOrders.paginator,
  repairOrders,
  repairOrderDetail,
  repairOrderLineItems: repairOrderLineItems.paginator,
  reports,
  reservedForRepairInventory: reservedForRepairInventory.paginator,
  reservedForSaleInventory: reservedForSaleInventory.paginator,
  salesReport: salesReport.paginator,
  users,
  userDetail,
  inventoryPagination: inventoryPagination.paginator,
  inventoryDetail,
  salesOrders,
  salesOrderDetail,
  salesOrderWithAllLineItemsDetail,
  outboundOrders: outboundOrders.paginator,
  shipmentsPagination,
  shipmentDetail,
  rmas: rmas.paginator,
  rmaDetail,
  subscriptions,
  upgrade,
  approvedVendors: approvedVendors.paginator,
  approvedRepairStations: approvedRepairStations.paginator,
  shoppingLists: shoppingLists.paginator,
  residentExpertSearch: residentExpertSearch.paginator,
  vendorRmas: vendorRmas.paginator
});



// WEBPACK FOOTER //
// ./app/reducers.js